import { ComputedRef, inject, InjectionKey, provide } from 'vue';
import dayjs from 'dayjs';
import date, { DateFormat } from '@/extensions/filters/date';

const PROVIDE_DATE_FORMAT_SYMBOL = Symbol('provide-date-format') as InjectionKey<DateFormatContext>;

type DateTypeof = typeof date;

interface DateFormatter {
  (value: dayjs.ConfigType, format?: DateFormat): string | dayjs.ConfigType;

  (...parameters: Parameters<DateTypeof>): ReturnType<DateTypeof>;
}

type DateFormatContext = {
  timezone?: ComputedRef<string | undefined>;
  formatter?: DateFormatter;
};

export const useDateFormatContext = () => {
  return inject(PROVIDE_DATE_FORMAT_SYMBOL, {
    formatter: date,
  });
};
export const provideDateFormatContext = ({ formatter, timezone }: DateFormatContext) => {
  const dateFormat = (...parameters: Parameters<DateFormatter>) => {
    return (formatter ?? date)(...parameters);
  };
  provide(PROVIDE_DATE_FORMAT_SYMBOL, {
    timezone,
    formatter: dateFormat,
  });
};
